import React from 'react';
import { createNavigationLinksLayoutClassName } from './navigationLinksLayoutStyles';

export const NavigationLinksLayout: React.FC = (props) => {
  const { children } = props;

  return (
    <div className={createNavigationLinksLayoutClassName('wrapper')}>
      {children}
    </div>
  );
};
